import { Component } from 'react';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { NavMarker } from 'react-rhumb';
import { logError } from '../utils/handleError';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      componentName
    } = this.props;
    logError({
      componentName: componentName || 'Unknown component',
      error,
      extra: errorInfo
    });
  }
  render() {
    const {
      children
    } = this.props;
    if (this.state.hasError) {
      return /*#__PURE__*/_jsxs(ErrorMessage, {
        type: "badRequest",
        children: [/*#__PURE__*/_jsx(NavMarker, {
          name: "ERROR_BOUNDARY"
        }), /*#__PURE__*/_jsx("p", {
          children: I18n.text('app.errors.loadFailed')
        })]
      });
    }
    return children;
  }
}
export default ErrorBoundary;